import { create } from "zustand";
import { UtilsStoreProps } from "./interface/utils.interface";
import { getFocusCompany, upsertFocusCompany } from "src/services/company.service";
import { UpsertFocusCompany } from "src/entity/company/focus-company.entity";
import { getAreaByCompany, getMaster } from "src/services/master.service";
import { Master } from "src/entity/report-voc-emission/report-voc-emission.entity";
import { QueryTarget, ResponseTarget, UpdateTargetBody } from "src/entity/target/target.entity";
import { getTarget, updateTarget } from "src/services/target.service";
import { targetStoreProps } from "./interface/target-store.interface";
import { profileStore } from "./profile-store";

export const targetStore = create<targetStoreProps>((set) => ({
  loading: false,
  loadingManage: false,
  data: [],
  error: null,

  getTarget: async (filter: QueryTarget) => {
    set(() => ({ loading: true }));
    try {
      const response = await getTarget(filter);

      const data: ResponseTarget[] = response.data?.data || [];
      const profile = profileStore.getState().profile;
      const availableCompany = profile?.company ?? [];
      const attachNoColumn = data
        .filter(
          (item) => (item.companyId?._id && availableCompany.find((avaCompany) => avaCompany._id == item.companyId?._id)) || item.alias,
        )
        .map((item, index) => ({ ...item, no: index + 1 }));

      set(() => ({ loading: false, data: attachNoColumn }));
    } catch (error) {
      set(() => ({ loading: false }));
    }
  },
  updateTarget: async (body: UpdateTargetBody) => {
    set(() => ({ loadingManage: true }));
    try {
      await updateTarget(body);
      set(() => ({ loadingManage: false }));
    } catch (error) {
      set(() => ({ loadingManage: false }));
    }
  },
  setDataTarget: (lists: ResponseTarget[]) => {
    set(() => ({ data: lists }));
  },
}));
